import { render, staticRenderFns } from "./EmployeeAvatar.vue?vue&type=template&id=7c1405d4&scoped=true"
import script from "./EmployeeAvatar.vue?vue&type=script&lang=js"
export * from "./EmployeeAvatar.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAvatar.vue?vue&type=style&index=0&id=7c1405d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1405d4",
  null
  
)

export default component.exports